import { Box } from '@theme-ui/components';
import styled from '@emotion/styled';

import fontSizes from '@app/styles/theme/fontSizes';
import { rem } from '@app/styles/theme/layout';

export const ContentWrapper = styled(Box)`
  max-width: ${rem(1170)};
  margin: 0 auto;
  width: 100%;
  font-size: ${fontSizes[2]};
`;

export const ContentTop = styled(Box)`
  text-align: center;
  h1,
  h2,
  h3 {
    font-size: ${rem(32)};
  }
  .text-body,
  p {
    font-size: 1rem;
    line-height: 1.5;
  }
  a {
    transition: color 0.3s;

    &:hover {
      color: ${({ theme }) => theme.colors.protectedContentLinkHover};
      transition: color 0.3s;
    }
  }
`;

export const ExtraInformation = styled(Box)`
  font-style: italic;
  font-size: ${fontSizes[2]};
  line-height: 1.5;
`;
